import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

const AMRegions = ({ userId }) => {
  const { openTimeModal } = useTimeModal();

  const [isFormChanged, setIsFormChanged] = React.useState(false);
  const [regions, setRegions] = React.useState([]);
  const [moreThanHalf, setMoreThanHalf] = React.useState(false);

  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [warning, setWarning] = React.useState('');
  const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

  const handleLogout = () => {
      localStorage.removeItem('token');
      window.location.href = '/';
  }

  React.useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) handleLogout();

      axios.get(`/api/get-user-regions?id=${userId}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          },
          params: { userId }
      }).then((response) => {
          setRegions(response.data);
          setMoreThanHalf(response.data.filter(r => r.isCheck).length > response.data.length / 2);
      }).catch((error) => {
          console.error(error);
          setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      }).finally(() => {
        setReload(false);
        setLoading(false);
      });
  }, [reload, userId]);

  const changeData = (regionId, check, isAllRegions) => {
    const token = localStorage.getItem('token');

    axios.put('/api/change-user-region', {
        user_id: userId,
        region_id: regionId,
        check: check,
        is_all_regions: isAllRegions,
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }
    )
    .then(() => {
      setStatus(<a>Данные сохранены</a>);
      openTimeModal('Данные успешно сохранены', 'success');
      setReload(true);
      setIsFormChanged(false);
    })
    .catch((error) => {
      console.error(error);
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
  };
  

  return (
    <div className='pageLimiter'>
      <div className='panel'>
        <p style={{fontSize: '14px'}}>Отметьте регионы, по которым хотите получать предложения дел при рассылке</p>
      </div>
      {loading ? <Loading />
      : warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} />
      :
      <>
        <div className='panel'>
          <div 
            style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px', borderBottom: '1px solid #e5e5e5', paddingBottom: '10px', marginBottom: '10px'}}
          >
              <p style={{fontSize: '14px'}}>Отметить все</p>
              <button type='button' className='button miniButton' style={{width: 'fit-content'}} onClick={() => {changeData(null, !moreThanHalf, true)}}>{moreThanHalf ? 'Снять отметку со всех' : 'Отметить все'}</button>
          </div>

          <div className='threeColumnsGrid'>
            {regions.map((region) => (
                <div 
                  key={region.id}
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px'}}
                >
                    <p style={{fontSize: '14px'}}>{region.name}</p>
                    <div className='labelInputRight'>
                        <p className='checkboxWrapper'>
                            <label className='switch' htmlFor={`region_${region.id}`}>
                                <input type='checkbox' id={`region_${region.id}`} checked={region.isCheck} onChange={() => {changeData(region.id, !region.isCheck, false)}} />
                                <div className='slider round'></div>
                            </label>
                        </p>
                    </div>
                </div>
            ))}
          </div>
        </div>
      </>
      }
    </div>
  )
}

export default AMRegions;